import React from 'react';
import {
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';

const statusLabels = {
  over_limit: { label: 'Over limit', color: 'error' },
  near_limit: { label: 'Near limit', color: 'warning' },
  normal: { label: 'Normal', color: 'success' },
  unconfigured: { label: 'No limit set', color: 'default' },
  all_time: { label: 'All-time total', color: 'default' },
};

const CommunicationUsageTable = ({ organizations }) => (
  <TableContainer component={Paper} variant="outlined">
    <Table>
      <TableHead sx={{ bgcolor: '#f8fafc' }}>
        <TableRow>
          <TableCell>Church</TableCell>
          <TableCell align="right">SMS sent</TableCell>
          <TableCell align="right">SMS segments</TableCell>
          <TableCell align="right">Emails sent</TableCell>
          <TableCell align="right">Failed</TableCell>
          <TableCell align="right">Tracked spend</TableCell>
          <TableCell>Status</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {organizations.map((row) => {
          const status = statusLabels[row.usageStatus];
          return (
            <TableRow key={row.organization.id} hover>
              <TableCell>
                <Typography fontWeight={600}>{row.organization.name}</Typography>
                <Typography variant="caption" color="text.secondary">{row.organization.slug}</Typography>
              </TableCell>
              <TableCell align="right">{row.sms.messages.toLocaleString()}</TableCell>
              <TableCell align="right">{row.sms.segments.toLocaleString()}</TableCell>
              <TableCell align="right">{row.email.messages.toLocaleString()}</TableCell>
              <TableCell align="right">{(row.sms.failed + row.email.failed).toLocaleString()}</TableCell>
              <TableCell align="right">
                {row.estimatedCost !== null
                  ? `$${row.estimatedCost.toFixed(2)}`
                  : row.actualSmsCost > 0
                    ? `${row.actualSmsCurrency || ''} ${row.actualSmsCost.toFixed(2)}`.trim()
                    : '—'}
              </TableCell>
              <TableCell><Chip size="small" label={status.label} color={status.color} /></TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  </TableContainer>
);

export default CommunicationUsageTable;
